import { getErrorMessage } from "@/core/services";
import { useAsyncQuery } from "@/ds";
import { listMoedasProjecao } from "@/modules/financeiro-obras/financeiro-obras.projecao.gateway";
import type { MoedaOpcao } from "@/modules/financeiro-obras/financeiro-obras.projecao.types";

const SEM_MOEDAS: MoedaOpcao[] = [];

const MOEDAS_CATALOGO_PERMISSAO = "Você não tem permissão para consultar as moedas.";
const MOEDAS_CATALOGO_ERRO = "Não foi possível carregar as moedas.";

export function useMoedasCatalogo({ enabled = true }: { enabled?: boolean } = {}) {
  const { status, data, errorMessage, reload } = useAsyncQuery({
    fetcher: (signal: AbortSignal) => listMoedasProjecao({ signal }),
    queryKey: "moedas-catalogo",
    enabled,
    initialData: SEM_MOEDAS,
    forbiddenMessage: MOEDAS_CATALOGO_PERMISSAO,
    errorMessage: MOEDAS_CATALOGO_ERRO,
    resolveErrorMessage: getErrorMessage,
  });

  return { status, moedas: data, errorMessage, recarregar: reload };
}
